<template>
  <div class="content">
    <div class="header_top">
      <div class="header_in">
        <div>
          <p>欢迎来到智污邦环保服务平台</p>
          <ul>
            <!-- <li>登录</li> -->
            <li v-if="$store.state.user.userInfo">{{ $store.state.user.userInfo.data.name }}</li>

            <router-link v-else target="li" to="/login">登录</router-link>
		      	<router-link v-if="$store.state.user.userInfo == null"   target="li" to="/register">免费注册</router-link>
            <!-- <li>免费注册</li> -->
            <!-- <li>找回密码</li> -->
           <router-link v-if="hide == true"  target="li" to="/retrieve">找回密码</router-link>
            <li v-if="$store.state.user.userInfo && $store.state.user.userInfo.type"  style="margin-left:20px;cursor: pointer;" @click.prevent="logOut()">退出登录</li>
          </ul>
        </div>
        <div>
          <ul>
            <!-- <li>快速发布信息</li> -->
            <router-link v-if="$store.state.user.userInfo != null"  target="li" to="/demandAdd">快速发布信息</router-link>
            <router-link target="li" to="/platform_entry">入驻平台</router-link>
            <!-- <li>入驻平台</li> -->
            <!-- <li>帮助中心</li> -->
            <router-link target="li" to="/help_center">帮助中心</router-link>
            <!-- <li>个人中心</li> -->
            <router-link v-if="userType == 3"  target="li" to="/corporate_account">个人中心</router-link>
            <router-link v-else  target="li" to="/number">个人中心</router-link>
          </ul>
        </div>
      </div>
    </div>
    <div class="header_body">
      <router-link to="/">
        <img class="search_logo" src="../assets/images/logo.jpg" alt=""
      /></router-link>
      <div class="header_cox" v-if="userInfo">
        <div class="cox_title">
            <p>{{userInfo.name}}</p>
            <!-- <img src="@/assets/images/member.png" alt=""> -->
        </div>
        <div class="cox_text">{{userInfo.businessScope}}</div>
      </div>
    </div>
    <div class="header_nav">
      <ul>
        <router-link active-class="active" target="li" to="/corporate_detail" exact
          >公司首页</router-link
        >

        <router-link
          active-class="active"
          target="li"
          to="/corporate_supply_all"
          exact
          >供应产品</router-link
        >

        <router-link active-class="active" target="li" to="/corporate_demand" exact
          >企业需求</router-link
        >

        <router-link
          active-class="active"
          target="li"
          to="/corporate_introduce"
          exact
          >公司简介</router-link
        >

        <router-link active-class="active" target="li" to="/corporate_list_all" exact
          >公司资讯</router-link
        >

        <router-link active-class="active" target="li" to="/corporate_case_all" exact
          >经典案例</router-link
        >

        <router-link active-class="active" target="li" to="/corporate_qualifications" exact
          >企业资质</router-link
        >
      </ul>
    </div>
  </div>
</template>

<script>
import {toLogin} from "@/utils";
import { getUserInfo} from "@/api/information";
import {getToken} from '@/utils/auth'
export default {
  name: "headCom",
  data(){
    return{
      id:null,
      hide:false,
      userType:''
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.companyInfo;
    },
    userinfoType() {
      return (
        this.$store.state.user.userInfo && this.$store.state.user.userInfo.type
      );
    },
  },
  created(){
    this.id = sessionStorage.getItem('corporateId');
    if(this.$store.state.user.userInfo !=null){
       this.id = this.$store.getters.companyInfo.userId;
       this.hide = false
    }else{
      this.hide = true;
    }
    if(getToken() == undefined){
      this.$store.dispatch("user/logout");
    }
  },
  watch:{
    userinfoType:{
      handler(val){
        this.userType = val;
      },
      immediate: true,
    }
  },
  methods:{
    logOut(){
      localStorage.clear();
      // this.setCookie("", "", 0);
      this.$store.dispatch("user/logout");
      toLogin();
      this.$router.push('/login')
    },
    getUser(){
      let params = { id:this.id}
      getUserInfo(params).then((res)=>{
        if(res.code == 0){}
      }).catch((err)=>{})
    }
  }
};
</script>

<style scoped lang="less">
.header_top {
  width: 100%;
  line-height: 31px;
  background: #f0f0f0;
  .header_in {
    width: 1080px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    // @media (min-width: 1600px) {
    //   width: 60%;
    // }
    div,
    ul {
      display: flex;
      justify-content: space-between;
      p,
      li {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
      }
      p {
        margin-right: 54px;
      }
      li {
        margin: 0 5px;
      }
      a {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        padding-left: 20px;
      }
    }
  }
}
.header_body {
  position: relative;
  width: 1080px;
  margin: 0 auto;
//   height: 150px;
  padding: 35px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  //  @media (min-width: 1600px) {
  //     width: 60%;
  //   }
  .search_logo{
      width: 189px;
      height: 59px;
  }
  .header_cox{
      flex: 1;
      margin-left: 60px;
  }
  .cox_title{
    display: flex;
    justify-content:flex-start;
    align-items: center;
    p{
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
    }
    img{
        width: 26px;
        height: 26px;
        padding-left: 10px;
    }
  }
  .cox_text{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 22px;
	max-height: 63px;
	overflow: hidden;		
	text-overflow: -o-ellipsis-lastline;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
  }
}
.header_nav {
  width: 100%;
  height: 67px;
  background: url("../assets/images/bg.jpg") no-repeat center/cover;
  ul {
    display: flex;
    justify-content: space-between;
    width: 1080px;
    line-height: 67px;
    margin: 0 auto;
    // @media (min-width: 1600px) {
    //   width: 60%;
    // }
    a {
      width: 100px;
      font-size: 16px;
      text-align: center;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      transition: 0.5s;
    }
    .active {
      background: rgba(86, 151, 23, 1);
      // position: relative;
      // &::after {
      //   animation: move 0.5s;
      //   position: absolute;
      //   bottom: 0;
      //   display: flex;
      //   content: "";
      //   width: 100%;
      //   height: 2px;
      //   background: #569717;
      // }
    }
  }
}

@keyframes move {
  from {
    width: 0px;
  }
  to {
    width: 100px;
  }
}

@-moz-keyframes move /* Firefox */ {
  from {
    width: 0px;
  }
  to {
    width: 100px;
  }
}

@-webkit-keyframes move /* Safari 和 Chrome */ {
  from {
    width: 0px;
  }
  to {
    width: 100px;
  }
}

@-o-keyframes move /* Opera */ {
  from {
    width: 0px;
  }
  to {
    width: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/headEnterprise.vue